export default "__VITE_ASSET__CW5_EGT9__"